import MapCharacterDefinition from "./MapCharacterDefinition";
import MapLocationDefinition from "./MapLocationDefinition";

export default class MapDefinition {
    constructor(id, movieClipName, locations, characters) {
        this._id = id;
        this._movieClipName = movieClipName;
        this._locations = locations || [];
        this._characters = characters || [];
    }

    get id() {
        return this._id;
    }

    get movieClipName() {
        return this._movieClipName;
    }

    /**
     * @return {Array<MapLocationDefinition>}
     */
    get locations() {
        return this._locations;
    }

    /**
    * @return {Array<MapCharacterDefinition>}
    */
    get characters() {
        return this._characters;
    }
}
